import React, { useState } from 'react';
import Layout from '../../components/Layout/Layout';
import SecondaryCategories from '../../components/SecondaryCategories/SecondaryCategories';
import styles from './SecondaryCategoriesPage.module.css';

const SecondaryCategoriesPage = () => {
  const [selectedCategory, setSelectedCategory] = useState(9); // Iniciamos con ID 9 como está en el componente original

  const handleCategorySelect = (categoryId) => {
    console.log(`Category selected: ${categoryId}`);
    setSelectedCategory(categoryId);
  };

  return (
    <Layout width="1440px">
      <div className={styles.secondaryCategoriesStack}>
        <SecondaryCategories
          size="Desktop 1440"
          selectedCategory={selectedCategory}
          onCategorySelect={handleCategorySelect}
        />
      </div>
    </Layout>
  );
};

export default SecondaryCategoriesPage;